
import { useState } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import PortfolioSection from './components/PortfolioSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      <HeroSection />
      <ServicesPreview />
      <PortfolioSection setActiveSection={setActiveSection} />
      <HowItWorksSection setActiveSection={setActiveSection} />
      <BenefitsSection setActiveSection={setActiveSection} />
      <AboutSection setActiveSection={setActiveSection} />
      <ContactSection setActiveSection={setActiveSection} />
    </div>
  );
};

export default HomePage;
